import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cartoes-fisicos',
  templateUrl: './cartoes-fisicos.component.html',
  styleUrls: ['./cartoes-fisicos.component.css']
})
export class CartoesFisicosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
